import { toast } from "sonner";

import { mapErrors } from "@/api/mapErrors";

// One reading of a failed mutation for every surface (Rule 6): the global
// toast and the Zero betslip's inline notice must print the same sentence.
// `t` is threaded in as an argument so this stays a plain helper — it is
// called from places that cannot call hooks (the query client's defaults).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Translate = (key: string, values?: Record<string, any>) => string;

/** The translated description of a failed mutation (the backend's tranKey, else its message). */
export const describeMutationError = (t: Translate, error: Error): string =>
  explainMutationError(t, error).message;

/**
 * The description together with the typed reason it was built from, for a
 * surface that reads more than the sentence (the Zero betslip shows how much
 * still fits under a risk limit).
 */
export const explainMutationError = (
  t: Translate,
  error: Error,
): { message: string; tranKey: string | null; params: Record<string, string | number> | null } => {
  const errors = mapErrors(error);
  const message = errors.tranKey
    ? t(errors.tranKey, { defaultValue: errors.message, ...(errors.tranParams ?? {}) })
    : errors.message;
  return { message, tranKey: errors.tranKey ?? null, params: errors.tranParams ?? null };
};

/** The default surface: sonner's error toast, titled "İşlem başarısız". */
export const notifyMutationError = (t: Translate, error: Error): void => {
  toast.error(t("shared.operation_failed"), {
    description: describeMutationError(t, error),
  });
};
